import { gql } from '@apollo/client';

export const DELETE_COMMUNITY_POLICY = gql`
  mutation DeleteCommunityPolicy($communityId: ID!, $input: DeletePolicyInput!) {
    deletePolicy(communityId: $communityId, input: $input)
  }
`;
